function createOption(value: string) {
  return {
    label: value,
    value,
  };
}

/** 工厂options*/
export const factoryOptions = [
  {
    label: "E1",
    value: "1000",
  },
  {
    label: "E2",
    value: "2000",
  },
  {
    label: "E4",
    value: "4000",
  },
  {
    label: "E5",
    value: "3000",
  },
];
/**
 * 寻源类别options
 */
export const sourcingTypeOptions = ["生产物料", "非生产物料"].map((item) =>
  createOption(item),
);

/**
 * 生产物料对应的寻源子类别
 */
const productionMaterialOptions = ["API", "輔料", "包材"].map((item) =>
  createOption(item),
);

/**
 * 生产物料对应的寻源子类别
 */
const nonProductionMaterialOptions = [
  "新项目",
  "工程建设",
  "设备/设施/仪器",
  "IT物资",
].map((item) => createOption(item));

/**
 * 根据寻源类别获取对应的寻源子类别options
 * @param sourcingType
 * @returns
 */
export function getSubSourcingTypeOptions(sourcingType: string) {
  if (sourcingType === "生产物料") return productionMaterialOptions;

  return nonProductionMaterialOptions;
}

export const PurchaseRequestTypeMap = {
  /** R&D Raw Material 采购申请表 */
  RdRawMaterialRequisition: "RdRawMaterialRequisition",
  /** 参比制剂（RLD）采购申请表 */
  RldReferenceProductRequisition: "RldReferenceProductRequisition",
  /** 高金额采购申请表 */
  HighValuePurchaseRequisition: "HighValuePurchaseRequisition",
  /** 低金额采购申请表 */
  LowValuePurchaseRequisition: "LowValuePurchaseRequisition",
} as const;

export const PurchaseRequestTypeZH = {
  [PurchaseRequestTypeMap.RdRawMaterialRequisition]:
    "R&D Raw Material 采购申请表",
  [PurchaseRequestTypeMap.RldReferenceProductRequisition]:
    "参比制剂（RLD）采购申请表",
  [PurchaseRequestTypeMap.HighValuePurchaseRequisition]: "高金额采购申请表",
  [PurchaseRequestTypeMap.LowValuePurchaseRequisition]: "低金额采购申请表",
} as const;

export const PurchaseRequestTypeOptions = Object.values(
  PurchaseRequestTypeMap,
).map((type) => ({
  label: PurchaseRequestTypeZH[type],
  value: type,
}));

/** 采购申请表类型 */
export type PurchaseRequestType =
  (typeof PurchaseRequestTypeMap)[keyof typeof PurchaseRequestTypeMap];

/** 单位选项 */
export const unitOptions = [
  { label: "卷", value: "Roll" },
  { label: "公斤", value: "KG" },
  { label: "包/袋", value: "Pack" },
  { label: "个", value: "PCS" },
  { label: "管", value: "Tube" },
  { label: "磅", value: "lb" },
  { label: "克", value: "g" },
  { label: "盒", value: "Box" },
];

/** 预算类型 */
export const budgetTypeOptions = [
  { label: "Departmental Budget 部門年度預算", value: "A" },
  { label: "Project 項目預算", value: "B" },
  { label: "BE Funding 項目預算", value: "C" },
  { label: "No Budget 沒有預算", value: "D" },
];

/** 币种 */
export const CURRENCY_OPTIONS = [
  { label: "AUD", value: "AUD" },
  { label: "CAD", value: "CAD" },
  { label: "CNY", value: "CNY" },
  { label: "EUR", value: "EUR" },
  { label: "GBP", value: "GBP" },
  { label: "HKD", value: "HKD" },
  { label: "JPY", value: "JPY" },
  { label: "SEK", value: "SEK" },
  { label: "SGD", value: "SGD" },
  { label: "TWD", value: "TWD" },
  { label: "USD", value: "USD" },
];

/** 采购组 */
export const purchaseGroupOptions = [
  { label: "C01 Dir.Matl-Plant", value: "C01" },
  { label: "C02 Indir.Matl-MRO", value: "C02" },
  { label: "C03 Indir.Matl-Other", value: "C03" },
  { label: "C04 Dir.Matl Trial", value: "C04" },
  { label: "C06 Idir.Matl-R&D", value: "C06" },
  { label: "C08 AF Consumable", value: "C08" },
];

/** 寻源来源 */
export const sourcingOriginOptions = [
  { label: "计划内", value: "1" },
  { label: "计划外", value: "2" },
];

/** 寻源方法 */
export const sourcingMethodOptions = [
  { label: "单一", value: "1" },
  { label: "寻源", value: "2" },
];
